export default "__VITE_ASSET__GbuwaAi___"